import { useChain } from './useChain';

export const useIsFuelRollbackVoucherStackingEnabled = () => {
  const chain = useChain();
  return chain?.attributes?.isFuelRollbackVoucherStackingEnabled ?? false;
};
